export function convertFormDataToPayload(
  formData: Record<string, string | boolean | number>,
  consents: string[],
) {
  const payload = []
  //TODO: L&T Need v2 check -> in v2 send `fieldCode`, `fieldValue` | in v1 -> `id`, `value`
  for (const key in formData) {
    const fieldData = {
      id: key,
      value: trimValue(formData[key]),
      fieldCode: key,
      fieldValue: trimValue(formData[key]),
    }
    payload.push(fieldData)
  }

  let consent: {
    value: string
    type: string
  }[] = []
  if (consents?.length) {
    consent = consents.map((item) => ({
      value: item.replace(/<[^>]*>?/gm, ''),
      type: 'CHECK_BOX',
    }))
  }
  return payload.length ? { data: payload, consent } : null
}

function trimValue(value: string | boolean | number) {
  return (typeof value === 'string' ? value?.trim?.() : value) ?? null
}
